import {
  SET_CALCULATING,
  SET_CALCULATING_TOPIC,
  SET_CALCULATING_CATEGORY,
  SET_CALCULATING_COUNTRY,
  SET_CALCULATION_STATUS,
  SET_CALCULATION_LIST,
  DELETE_CALCULATION,
  SET_CALCULATION_DEFAULT_API_DATA
} from './action';

import {saveCalculation,loadCalculations,deleteCalculation} from '../services/calculation';

import {getTemplateTopicsData,injectAPIDataInTemplate} from '../services/countryData';

const setCalculating=(template)=>{
  return {
    type: SET_CALCULATING,
    template
  }
}

const setCalculationList=(calcList)=>{
  return {
    type: SET_CALCULATION_LIST,
    calcList
  }
}

const setCalculationDefaultApiData=(apiData)=>{
  return {
    type: SET_CALCULATION_DEFAULT_API_DATA,
    apiData
  }
}

const removeCalculation=(id)=>{
  return {
    type: DELETE_CALCULATION,
    id
  }
}

const setCalculatingTopic=(topic,index,index1)=>{
  return {
    type: SET_CALCULATING_TOPIC,
    topic,
    index,
    index1
  }
}

const setCalculatingCategory=(index,prop,value)=>{
  return {
    type: SET_CALCULATING_CATEGORY,
    index,
    prop,
    value
  }
}

const setCalculatingCountry=(countryData)=>{
  return {
    type: SET_CALCULATING_COUNTRY,
    countryData
  }
}

const setCalculationStatus=(status)=>{
  return {
    type: SET_CALCULATION_STATUS,
    status
  }
}


const startSavingCalculation=(calc)=>{
  return async dispatch => {
    try {

      dispatch(setCalculationStatus('loading'));
      const savedCalc = await saveCalculation(calc);
      
      dispatch(startLoadingCalculations());
      return savedCalc;
    } catch(e) {
      dispatch(setCalculationStatus(''));
      console.log('ERROR STARTSAVINGCALCULATION!',e);
    }
  }
}

const startLoadingCalculations=()=>{
  return async dispatch =>{
    try {
      dispatch(setCalculationStatus('loading'));
      const calcs = await loadCalculations();
      dispatch(setCalculationList(calcs));
      return calcs;
    } catch(e) {
      dispatch(setCalculationStatus(''));
      console.log('ERROR STARTLOADINGCALCULATION!',e);

    }
  }
}

const startDeletingCalculation=(id)=>{
  return async dispatch =>{
    try {
      dispatch(setCalculationStatus('loading'));
      const ret = await deleteCalculation(id);
      dispatch(removeCalculation(id));
      return ret;
    } catch(e) {
      dispatch(setCalculationStatus(''));
      console.log('ERROR STARTDELETINGCALCULATION!',e);

    }
  }
}


const startLoadingCalculatingTopicData=(calculating)=>{
  return async dispatch =>{
    try {
      dispatch(setCalculationStatus('loading'));
      const apiData = await getTemplateTopicsData(calculating);
      calculating=injectAPIDataInTemplate(calculating,apiData);
      dispatch(setCalculating(calculating));
      dispatch(setCalculationStatus(''));
      
      return true;
    } catch(e) {
      dispatch(setCalculationStatus(''));
      console.log('ERROR STARTLOADINGCALCULATINGTOPICDATA!',e);

    }
  }
}





export {
  setCalculating,
  setCalculatingTopic,
  setCalculatingCategory,
  setCalculatingCountry,
  startSavingCalculation,
  setCalculationList,
  startLoadingCalculations,
  startDeletingCalculation,
  setCalculationDefaultApiData,
  startLoadingCalculatingTopicData
}